// @flow

/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */
import { addToast, Toast } from '@react/react-spectrum/Toast';
import React from "react";
class GlobalUtil {

	constructor() {
		
	}

	showToast(msg, type) {
		addToast(
			<Toast closable variant={type}>
				{msg}
			</Toast>,5000,
		);
	}

    hasFeature(feature) {
		return window.cchome && window.cchome.util && window.cchome.util.hasFeature && window.cchome.util.hasFeature(feature);
	}

	isLoggedInUser() {
		return (typeof adobeIMS !== 'undefined') && adobeIMS.getUserProfile() && adobeIMS.getUserProfile().userId
	}

	trianleToolDraw = () => {}
	drawID = null
	trianleToolDrawOutline = () => {}
	drawOutlineID = null

	printLog = (log) => {
		const printLogFlag = this.hasFeature('temp_enable_cchome_apps_logs'); // don't enable the flag on production. It should only be used for debugging.
		if (printLogFlag) {
			console.log(log);
		}
	}

	dataURItoBlob = (dataURI) => {
		var byteString = atob(dataURI.split(',')[1]);
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
		  ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ab], { type: mimeString });
	}
	
	sessionStorageClear = () => {
		window.sessionStorage.removeItem('patternName');
		window.sessionStorage.removeItem('patternIndex');
		window.sessionStorage.removeItem('patternRotate');
		window.sessionStorage.removeItem('patternScale');
		window.sessionStorage.removeItem('patternDownloadDialog');
		window.sessionStorage.removeItem('patternOffsetY');
		window.sessionStorage.removeItem('patternOffsetX');
		window.sessionStorage.removeItem('patternImage');
	}

	imageURLtoDataURL = (url) => {
		var img = new Image();
    	img.crossOrigin = 'Anonymous';
    	img.onload = function(){
			var canvas = document.createElement('CANVAS'),
			ctx = canvas.getContext('2d'), dataURL;
			canvas.height = img.height;
			canvas.width = img.width;
			ctx.drawImage(img, 0, 0);
			dataURL = canvas.toDataURL("image/png");
			window.sessionStorage.setItem('patternImage',dataURL);
			canvas = null; 
    	};
    	img.src = url;
	}
}

export default new GlobalUtil();
